import React from 'react';

interface CardProps {
  type: 'success' | 'error' | null;
  message: string | null;
}

export const MessageCard = ({type, message}: CardProps) => {
  const isSuccess = type === 'success';
  // const isError = type === 'error';

  const cardStyle: React.CSSProperties = {
    padding: '12px 16px',
    borderRadius: '10px',
    marginBottom: '10px',
    backgroundColor: isSuccess ? '#f0fdf4' : '#fef2f2',
    gap: '10px',
  };

  return (
    <div>
      {type && message && (
        <div style={cardStyle}>
          <p style={{margin: 0}}>{message}</p>
        </div>
      )}
    </div>
  );
};
